/* src/app/compliance/partials/filesystem-bar/filesystem-bar.component.scss */
.pink {
  background: pink;
}
/*# sourceMappingURL=filesystem-bar.component.css.map */
